export default function toNumber(value) {
  return Math.floor(value)
    .toFixed(2)
    .replace(/\d(?=(\d{3})+\.)/g, '$&,')
    .split('.')
    .shift();
};
